import ApiService from './api.service'
import { TokenService } from './storage.service'
import i18n from '@/core/plugins/vue-i18n'
import { bus } from '@/main';
import Api from "vue-loading-overlay/src/js/api";
import router from '../router/router';
class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
     **/
    forGetConfirm(data) {
        return ApiService.post("/change-new-password", data)
    },
    forgetPassword(data) {
        return ApiService.post(`/send-message-for-forget`, data)
    },
    forGetPassword(data) {
        let phone = "";
        if (data.phone !== "") {
            const phonelist = data.phone.split(" ");
            phone =
                phonelist[0] +
                phonelist[1] +
                phonelist[2] +
                phonelist[3] +
                phonelist[4];
        }

        let data2 = {
            username: data.username,
            email: data.email,
            phone: phone !== "" ? phone : "",
            passportNumber: data.passportNumber,
            passportSerialId: data.passportSerialId !== null ? data.passportSerialId.id : null,
            passportSerialTitle: data.passportSerialId !== null ? data.passportSerialId.title : null,
        }
        return ApiService.post("/send-message-for-forget", data2)
    },
    login: async function (userData) {
        const requestData = {
            method: 'post',
            url: '/auth-payload',
            data: {
                username: userData.username,
                password: userData.password
            }
        };

        try {
            const response = await ApiService.customRequest(requestData);
            await TokenService.saveToken(response.data.token);
            await TokenService.setUserName(response.data.username);
            await localStorage.setItem("language", "uz")
            ApiService.setHeader();
            ApiService.mount401Interceptor();

            return response.data;
        } catch (error) {
            bus.$toast.error(i18n.t("error.title"));
            // throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },
    register: async function (userData) {
        const requestData = {
            method: 'post',
            url: '/send-message',
            data: {
                "email": userData.email,
                "firstName": userData.firstName,
                "lastName": userData.lastName,
                "passportNumber": userData.passportNumber,
                "passportSerialTitle": userData.passportSerialTitle.title,
                "password": userData.password,
                "username": userData.username,
            }
        };
        try {
            const response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },
    registerPhone: async function (userData) {

        const requestData = {
            method: 'post',
            url: '/send-message-phone',
            data: {
                "phone": userData.phone,
                "firstName": userData.firstName,
                "lastName": userData.lastName,
                "passportNumber": userData.passportNumber,
                "passportSerialTitle": userData.passportSerialTitle.title,
                "password": userData.password,
                "username": userData.username,
            }
        };
        try {
            const response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },

    nextRegister: async function (userData) {
        const requestData = {
            method: 'post',
            url: '/validate-passport',
            data: userData
        };
        return ApiService.customRequest(requestData);
    },
    confirm: async function (confirmCode, userData) {
        var dataAll;
        if (userData.email !== undefined) {
            this.dataAll = {
                firstName: userData.firstName,
                lastName: userData.lastName,
                username: userData.username,
                email: userData.email,
                password: userData.password,
                passportNumber: userData.passportNumber,
                passportSerialId: userData.passportSerialTitle.id,
                passportSerialTitle: userData.passportSerialTitle.title,
            }
        }
        if (userData.phone !== undefined) {
            this.dataAll = {
                firstName: userData.firstName,
                lastName: userData.lastName,
                username: userData.username,
                phone: userData.phone,
                password: userData.password,
                passportNumber: userData.passportNumber,
                passportSerialId: userData.passportSerialTitle.id,
                passportSerialTitle: userData.passportSerialTitle.title,
            }
        }

        const requestData = {
            method: 'post',
            url: '/confirm-reset',
            params: {
                token: confirmCode.code
            },
            data: this.dataAll
        };
        try {
            const response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },
    adminGenerate: async function () {
        await ApiService.get('/generate')
    },
    /** Login by ESP **/
    loginByEsp: async function (userData) {
        const requestData = {
            method: 'post',
            url: '/auth-payload',
            data: userData
        };

        try {
            const response = await ApiService.customRequest(requestData)
            await TokenService.saveToken(response.data.token);
            await TokenService.setUserName(response.data.username);
            ApiService.setHeader();
            ApiService.mount401Interceptor();
            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
     **/
    async logout() {
        // Remove the token and remove Authorization header from Api Service as well
        TokenService.removeToken();
        TokenService.removeCurrentUserId();
        TokenService.removeUserName()
        TokenService.removeTest()
        TokenService.DEP_CURRENCY_ID()
        TokenService.removeExpire()
        ApiService.removeHeader();
        ApiService.unmount401Interceptor()
        if (window.location.pathname == '/oneId') {
            router.push("/")
        }
        setTimeout(() => {
            window.location.reload();
        }, 500);
    },
    updatePassword(data) {
        return ApiService.post('/user/update-password', data)
    },

    getKeyForLoginSign(inn) {
        return ApiService.get(`/keyForLoginSign?inn=${inn}`)
    },
    loginRequestToOneId(code, state) {
        return ApiService.get(`/redirectUri?code=${code}&state=${state}`);
    },
};

export { UserService, AuthenticationError };
